import React from "react";

interface ProgressIndicatorProps {
  steps: string[];
  currentStep: number; // 0-based
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  steps,
  currentStep,
}) => {
  return (
    <ol className="flex items-center w-full pl-[15%] pr-[15%]">
      {steps.map((label, idx) => {
        const done = idx < currentStep;
        const active = idx === currentStep;

        return (
          <li key={idx} className="flex-1 flex flex-col items-center">
            <div className="flex items-center w-full">
              {/* ALWAYS render left half-line; transparent if idx===0 */}
              <div
                className={`flex-1 h-0.5 ${
                  idx === 0
                    ? "bg-transparent"
                    : done || active
                    ? "bg-green-500"
                    : "bg-gray-300"
                }`}
              />

              {/* Dot */}
              <div
                className={`w-3 h-3 rounded-full ${
                  done || active ? "bg-green-500" : "bg-gray-300"
                }`}
              />

              {/* ALWAYS render right half-line; transparent if last */}
              <div
                className={`flex-1 h-0.5 ${
                  idx === steps.length - 1
                    ? "bg-transparent"
                    : idx < currentStep
                    ? "bg-green-500"
                    : "bg-gray-300"
                }`}
              />
            </div>

            {/* Label perfectly centered under dot */}
            <p className="mt-2 text-xs text-center whitespace-nowrap">
              {label}
            </p>
          </li>
        );
      })}
    </ol>
  );
};

export default ProgressIndicator;
